// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { PAGE_FROM_GENERAL, pushObdTop } from '../../../router/obd';

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import loading from '../../../share/components/vue/ProcessingIcon';
import svgIcon from '../../../share/components/vue/SVGIcon';
import alert from '../../../share/alert';
import cstmCard from "../../../share/components/vue/CustomCard";
import util from '../../../share/util/utils';
import ssm4Modal from '../../vue/StartSSM4Modal';
import reprogram from '../../../share/util/reprogram';
import api from '../../../common/api';
import handler from '../../../share/util/apiResultValidator';

const SELECTABLE = 'selectable';
const UNSELECTABLE = 'unselectable';

export default {
  name: 'menuPage',
  data() {
    return {
      processing: false,
      isReprogrammable: true,
      rprIconStyle: SELECTABLE,
      dtcIconStyle: SELECTABLE,
      imbIconStyle: SELECTABLE,
      macIconStyle: SELECTABLE,
      specialFeatureStyle: SELECTABLE,
      individualStyle: SELECTABLE,
      multiplelStyle: SELECTABLE,
      obdIconStyle: SELECTABLE,
      realWorldDataIconStyle: SELECTABLE,
      ssm4IconStyle: SELECTABLE,
      systemTables: { published: null, unpublished: null },
      switchRepro: {
        menuIconKey: "warningIcon",
        mainType: "noRepro",
        styleActive: "non",
        validRepro: 'message.common_hyphen',
        invalidRepro: 'message.common_hyphen'
      },
      switchDtc: {
        menuIconKey: "warningIcon",
        mainType: "noDtc",
        styleActive: "non",
        validDtc: 'message.common_hyphen',
        invalidDtc: 'message.common_hyphen'
      },
      individualMenuList: [],
      multipleMenuList: [],
      modalSSM4Form: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'home') {
      // 確認画面skipの情報が設定されているかチェック
      if ('isConfirmSkip' in to.params) {
        if (util.parseBoolean(to.params.isConfirmSkip)) {
          // HOME画面遷移の確認ダイアログ抑止フラグが立っていればOFFにする
          to.params.isConfirmSkip = false;
          next();
          return;
        }
      }
      const messages = this.$t('message.message_vehicle_dtc_confirm_back_home');
      alert.showConfirmation(this, null, messages, () => {
        // OKボタンが押下された場合はstart画面に戻す
        this.clearTableData();
        next();
      });
    }
    else {
      next();
    }
  },

  components: {
    'cstm-card': cstmCard,
    'processing-view': loading,
    'svg-icon': svgIcon,
    'ssm4-modal': ssm4Modal,
  },

  computed: {
    ...mapState({
      group: state => state.userProperty.group,
      isAlongToCompany: state => state.userProperty.isAlongToCompany,
      netAppId: state => state.netAppConnector.pairingAppId,
      code(state) {
        let code = state.userProperty.companyId;
        if (!state.userProperty.isAlongToCompany) {
          code = state.userProperty.shopId;
        }
        return code;
      },
      userCompanyInfo: state => state.userProperty.userCompanyInfo,
      resources: state => state.masterResources.targetUnits,
      authGroup: state => state.userProperty.group,
      targetUnit: state => state.targetUnit.unitInfo,
      systemTable: state => state.table.systemTable,
      allDtcSystems: state => state.table.allDtcSystems,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      isSSM4Supported: state => state.vehicle.vehicleInfo?.is_ssm4_supported || false,
      isTestMode: state => state.netAppConnector.isTestMode,
      isTechnicalHq: state => state.userProperty.userInfo.isTechnicalHq,
      isImbSupport: state => state.immobilizer.isImbSupport,
      imbMenuList: state => state.immobilizer.menuList,
      isMacSupport: state => state.macKey.isMacSupport,
      individualMenus: state => state.vehicle.individualMenus,
      realWorldDataMenus: state => state.vehicle.realWorldDataMenus,
      isRealWorldDataSupport: state => state.vehicle.isRealWorldDataSupport,
      language: state => state.systems.language,
      // 機能の利用可否
      isReproVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_RPR],
      isDiagVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_DIAG],
      isImbVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_IMMOBILIZER],
      isMackeyVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_MACKKEY],
      isIndividualDiagVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG],
      isDisplaySpecialFeature: state => state.userProperty.isSpecialSupport,
      isSpecialFeatureSupport: state => !state.netAppConnector.isTestMode,
      isRealWorldDataVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_REAL_WORLD_DATA],
      isObdVisible: state => state.userProperty.functionAvailability[config.FUNCTION_TYPE_OBD],
      isMultipleDiagVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_INDIVIDUAL_DIAG],
      multipleMenus: state => state.vehicle.multipleMenus,
    })
  },

  watch: {
    language: {
      handler(val) {
        val;
        // 言語切り替え時にソートさせる
        this.createIndividualMenus();
        this.createMultipleMenus();
      }
    },
  },

  methods: {
    ...mapActions('userProperty', ['setUserCompany']),
    ...mapActions('auth', ['logout']),
    ...mapActions('table', ['clearTableData']),
    ...mapActions('cache', ['cacheDisplayReproTypeMode']),
    ...mapActions('targetUnit', ['setTargetUnit']),

    //vehicleInfoが既販車であれば既販車リプログラミング画面へ遷移
    //それ以外であればSSM5対象車リプログラミング画面へ遷移
    openReprogramming: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        if (this.vehicleInfo.is_sold_vehicle) {
          this.$router.push({ name: 'soldVehicleSystemTable', params: { previousDisplayName: 'menu' } });
        } else {
          if (this.vehicleInfo.vehicle.is_su_flow) {
            this.$router.push({ name: 'suSystemTable', params: { previousDisplayName: 'menu' } });
          } else {
            this.$router.push({ name: 'systemTable', params: { previousDisplayName: 'menu' } });
          }
        }
      }
    },

    //DTC画面へ遷移
    openDTCList: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: 'dtcTable' });
      }
    },

    /**
     * システム個別診断画面へ遷移
     */
    openIndividualList: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: 'individualEcuTable' });
      }
    },

    //イモビ機能画面へ遷移
    openImobiFunction: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。      
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: 'immobilizer' });
      }
    },

    //MAC鍵登録画面へ遷移
    openMacKeyRegistration: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: 'macKey' });
      }
    },

    /**
     * OBDシステム画面に遷移する。
     */
    openObd: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        pushObdTop(this, PAGE_FROM_GENERAL);
      }
    },

    // 個車情報取得画面へ遷移
    openRealWorldDataList: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。      
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: config.REAL_WORLD_DATA_SELECT });
      }
    },

    /**
     * 特殊機能画面へ遷移
     */
    openSpecialFeatureList: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。      
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: 'specialFeatureEcuTable' });
      }
    },

    /**
     * システム複数診断メニュー画面へ遷移
     */
    openMultipleSelect: async function () {
      // 外部連携するサービスと車両通信の競合を回避するため、CC優先権を取得する。
      // 優先権を取得できた場合、後続の処理を行う。      
      const hasCCPriority = await this.enterCCPriority();
      if (hasCCPriority) {
        this.$router.push({ name: 'multipleSelect' });
      }
    },

    /**
     * SSM4起動ダイアログを表示
     */
    openSSM4: function () {
      // SSM4起動ダイアログ表示
      this.modalSSM4Form = true;
    },
    /** ウィザードを閉じた後の処理 */
    closeWizard() {
      this.modalSSM4Form = false;
    },

    //ユーザーの権限の確認
    isSystemAdmin: function () {
      return this.group === config.GROUP_SYSTEM;
    },

    isServiceAdmin: function () {
      return this.group === config.GROUP_SYSTEM || this.group === config.GROUP_SERVICE || this.group === config.GROUP_USER_ADMIN;
    },

    isDataAdmin: function () {
      let ret = false;
      // システム管理者・サービス管理者の場合、会社所属なら PFC 管理機能を使用可
      if (this.isServiceAdmin()) {
        ret = this.isAlongToCompany;
      }
      // 上記以外の場合、データ登録者なら店舗所属でも PFC 管理機能を使用可
      else {
        ret = this.group === config.GROUP_PFC || this.group === config.GROUP_REPRO_FILE_ADMIN || this.group === config.GROUP_REPRO_FILE_TESTER;
      }
      return ret;
    },

    // 下記のどちらかに当てはまっていたらリプログラミングボタンを表示する
    // 技本ユーザーで既販車判定だった場合ボタン表示
    // 技本ユーザー以外でSSM5対象車種だった場合ボタン表示
    isShowRprMenu: function () {
      return this.isTechnicalHq ? this.vehicleInfo.is_sold_vehicle : this.isReproVisible;
    },

    // リプログラミング有無の判定
    hasReprogrammableSystem: function (tblPblic) {
      // テストモードの場合は「リプロ有り」を設定する
      if (this.isTestMode) {
        // 判定のデフォルト設定
        this.switchRepro = {
          menuIconKey: "warningIcon",
          mainType: "availableRepro",
          styleActive: "activeRepro",
          validRepro: 'message.label_function_menu_available_reprogramming',
          invalidRepro: 'message.label_function_menu_no_reprogramming'
        };
        return true;
      }

      // リプロメニューの無効条件を設定
      // 1.機能対象外（SSM5非対応かつ既販車ではない）
      // 2.既販車：公開・非公開ともにデータが0件
      // 3.既販車以外：公開データが0件
      const isUnsupported = !this.vehicleInfo.is_ssm5_supported && !this.vehicleInfo.is_sold_vehicle;
      const hasNoPublicData = (tblPblic?.length ?? 0) === 0;
      const hasNoUnpublishedData = (this.systemTable?.unpublished?.length ?? 0) === 0;
      if (isUnsupported ||(this.vehicleInfo.is_sold_vehicle? (hasNoPublicData && hasNoUnpublishedData): hasNoPublicData)) {
        this.switchRepro.menuIconKey = "checkIcon";
        return false;
      }

      // 判定のデフォルト設定(repro無しの設定)
      this.switchRepro = {
        menuIconKey: "checkIcon",
        mainType: "noRepro",
        styleActive: "deactivateRepro",
        validRepro: 'message.label_function_menu_available_reprogramming',
        invalidRepro: 'message.label_function_menu_no_reprogramming'
      };

      // 既販車で取得した公開データが1件以上ある場合、menu画面はrepro有に設定
      if (this.vehicleInfo.is_sold_vehicle) {
        if (this.systemTable && (this.systemTable.published.length > 0)) {
          this.switchRepro.menuIconKey = "warningIcon";
          this.switchRepro.mainType = "availableRepro";
          this.switchRepro.styleActive = "activeRepro";
        }
      } else {
        // 搭載ECUが存在しない場合はデフォルト表示
        const installedTbl = tblPblic.filter(item => item.installation_status === config.REPRO_INSTALLED);
        if (installedTbl.length === 0) {
          return true;
        }

        const isRprgrammableStatus = (status) => { return status === config.REPRO_REPROGRAMMABLE; };
        const validRepro = tblPblic.filter(e => {
          const reprogrammableInfo = [e.reprogrammable_info.normal.reprogrammable_status, e.reprogrammable_info.merchantability.reprogrammable_status, e.reprogrammable_info.restore.reprogrammable_status];
          return reprogrammableInfo.some(i => { return isRprgrammableStatus(i); });
        });

        const noCommunicated = reprogram.hasFailedStateUnit(tblPblic, this.resources);
        // 取得した公開データに1件でもrepro有がある場合、menu画面はrepro有に設定
        if (validRepro.length > 0) {
          this.switchRepro.menuIconKey = "warningIcon";
          this.switchRepro.mainType = "availableRepro";
          this.switchRepro.styleActive = "activeRepro";
        }
        // 取得したデータに通信エラーが有る場合、menu画面は通信エラーを設定
        else if (noCommunicated) {
          this.switchRepro.menuIconKey = "errorIcon";
          this.switchRepro.mainType = "communicationError";
          this.switchRepro.warningRepro = 'message.label_function_menu_communication_error';
        }
      }
      return true;
    },

    // DTC有無の判定
    hasAllDtcSystem: function () {
      // DTCテーブル情報のDATAが空配列だった場合、menu 画面の診断ボタンをグレーアウト
      if (!this.vehicleInfo.is_ssm5_supported || this.allDtcSystems === null || this.allDtcSystems.data.length === 0) {
        this.switchDtc.menuIconKey = "checkIcon";
        return false;
      }

      // 判定のデフォルト設定
      this.switchDtc = {
        menuIconKey: "checkIcon",
        mainType: "noDtc",
        styleActive: "deactivateDtc",
        validDtc: 'message.label_function_menu_available_dtc',
        invalidDtc: 'message.label_function_menu_no_dtc'
      };
      const invalidDtc = this.allDtcSystems.data.filter(item => item.dtc_status === config.DTC_STATUS_NO_DTC || item.dtc_status === config.DTC_STATUS_DTC_NOT_SUPPORT || item.dtc_status === config.DTC_STATUS_CANNNOT_CONNECT).length;
      // 1件でもDTC有がある場合、menu画面はDTC有に設定
      if (invalidDtc !== this.allDtcSystems.data.length) {
        // menu画面にアイコンと状態表示を設定する
        this.switchDtc.menuIconKey = "warningIcon";
        this.switchDtc.mainType = "availableDtc";
        this.switchDtc.styleActive = "activeDtc";
      }
      else {
        const noDtc = this.allDtcSystems.data.filter(item => item.dtc_status === config.DTC_STATUS_NO_DTC).length;
        // すべてDTC無しの場合、menu画面はDTC無しに設定
        if (noDtc !== this.allDtcSystems.data.length) {
          // 通信エラーが有りがある場合、menu画面は通信エラーを設定
          for (let index = 0; index < this.allDtcSystems.data.length; index++) {
            if (this.allDtcSystems.data[index].dtc_status === config.DTC_STATUS_CANNNOT_CONNECT) {
              // menu画面にアイコンと状態表示を設定する
              this.switchDtc.menuIconKey = "errorIcon";
              this.switchDtc.mainType = "communicationError";
              this.switchDtc.warningDtc = 'message.label_function_menu_communication_error';
              return true;
            }
          }
        }
      }
      return true;
    },

    /**
     * 個別診断メニューのリストを作成する
     */
    createIndividualMenus: function () {
      const menuList = this.individualMenus && this.individualMenus.menu_list ? this.individualMenus.menu_list : [];
      // menu_display_configが存在する場合のみ、メニューリストを作成する
      this.individualMenuList = menuList.filter(menu => menu.menu_display_config);
    },

    /**
     * 個別診断メニュー一覧を表示するか否か
     */
    isShowIndividualMenu: function () {
      // 個別診断が利用不可な機能プラン、ssm5サポート対象外、表示リストが空の時は個別診断メニュー一覧を表示しない
      return this.isIndividualDiagVisible && this.vehicleInfo.is_ssm5_supported && this.individualMenuList.length !== 0;
    },

    /**
     * 複数診断メニューのリストを作成する
     */
    createMultipleMenus: function () {
      const menuList = this.multipleMenus && this.multipleMenus.menu_list ? this.multipleMenus.menu_list : [];
      // menu_display_configが存在する場合のみ、メニューリストを作成する
      this.multipleMenuList = menuList.filter(menu => menu.menu_display_config);
    },

    /**
     * 複数診断メニュー一覧を表示するか否か
     */
    isShowMultipleMenu: function () {
      // 個別診断が利用不可な機能プラン、ssm5サポート対象外、トレーニングモード時、表示リストが空の時は複数診断メニュー一覧を表示しない
      return this.isMultipleDiagVisible && this.vehicleInfo.is_ssm5_supported && !this.isTestMode && this.multipleMenuList.length !== 0;
    },

    /**
     * ph4メニュー利用可能な場合のメニュー項目の有効化可否を設定する
     */
    initPh4MenuStyles: function () {
      // DTC有無の確認
      this.dtcIconStyle = this.hasAllDtcSystem() ? SELECTABLE : UNSELECTABLE;

      // システム個別診断有無の確認
      this.individualStyle = this.isShowIndividualMenu() ? SELECTABLE : UNSELECTABLE;

      // IMB有無の確認
      this.imbIconStyle = this.isImbSupport && this.imbMenuList.length !== 0 ? SELECTABLE : UNSELECTABLE;

      // MAC鍵有無の確認
      this.macIconStyle = this.isMacSupport ? SELECTABLE : UNSELECTABLE;

      // 特殊機能有無の確認（テストモード以外、SSM5 対象車両の場合、選択可能）
      this.specialFeatureStyle = this.isSpecialFeatureSupport && this.vehicleInfo.is_ssm5_supported ? SELECTABLE : UNSELECTABLE;

      // システム複数診断有無の確認
      this.multiplelStyle = this.isShowMultipleMenu() ? SELECTABLE : UNSELECTABLE;

      // OBDシステム有無の確認
      this.obdIconStyle = this.isObdVisible && this.vehicleInfo.is_ssm5_supported && !this.isTestMode ? SELECTABLE : UNSELECTABLE;

      // リアルワールドデータ有無の確認
      this.realWorldDataIconStyle = this.isRealWorldDataVisible && this.isRealWorldDataSupport ? SELECTABLE : UNSELECTABLE;
    },

    /**
     * ph4メニュー利用不可な場合のメニュー項目の有効化可否を設定する
     */
    initNonPh4MenuStyles: function () {
      // ph4 メニュー項目無効化
      this.dtcIconStyle = UNSELECTABLE;
      this.individualStyle = UNSELECTABLE;
      // IMB有無の確認
      this.imbIconStyle = this.isImbSupport && this.imbMenuList.length !== 0 ? SELECTABLE : UNSELECTABLE;
      this.macIconStyle = UNSELECTABLE;
      this.specialFeatureStyle = UNSELECTABLE;
      this.multiplelStyle = UNSELECTABLE;
      this.obdIconStyle = UNSELECTABLE;
      this.realWorldDataIconStyle = UNSELECTABLE;
    },

    /**
     * ph4メニュー利用可否に応じて、メニュー項目の有効化可否を設定する
     */
    initMenuStyles: function () {
      if (this.vehicleInfo.vehicle?.vin?.ph4_menus_can_be_activated) {
        this.initPh4MenuStyles();
      } else {
        this.initNonPh4MenuStyles();
      }
    },

    /**
     * SSM4起動時の完全ログアウト処理
     * @param {*} isDialog 確認ダイアログ表示判定（true: 表示、false: 非表示）
     */
    tapLogout(isDialog) {
      // App.js の完全ログアウト処理を呼び出し
      this.$emit('tapLogout', isDialog);
    },

    // リプログラミングボタン文言設定
    menuLabel() {
      return this.vehicleInfo.is_sold_vehicle ? this.$t("message.label_function_menu_flash_write_reprogramming") : this.$t("message.label_function_menu_reprogramming");
    },

    // CC優先権を取得する
    // 同一ユーザー/同一CCで利用する外部サービスと車両通信が競合する恐れがあるため
    // それらを回避するために Cloud Connector の優先権を制御する
    async enterCCPriority() {
      this.processing = true;
      const param = {
        type: "lock",
        service: "ssm5"
      };
      const enterCCResponse = await api.postCall(config.REPRO, `/netApps/${this.netAppId}/usagePriority`, param);
      this.processing = false;
      let res = null;
      handler.validate(handler.validateTypes.all, enterCCResponse, this, null, () => {
        if (enterCCResponse.data.status) {
          res = true;
        } else {
          alert.showError(this, null, this.$t('error.CLOUD_CONNECTOR_UNAVAILABLE'));
          res = false;
        }
      }, (result) => {
        // 処理が失敗したときのコールバック処理
        if (result.behaviorType === handler.behaviorTypes.logout) {
          this.logout(this);
        }
      });
      // バリデーションが成功した場合の処理
      return res;
    },

    // CC優先権を破棄する
    // 同一ユーザー/同一CCで利用する外部サービスと車両通信が競合する恐れがあるため
    // それらを回避するために Cloud Connector の優先権を制御する
    async leaveCCPriority() {
      this.processing = true;
      const param = {
        type: "unlock",
        service: "ssm5"
      };
      const leaveCCResponse = await api.postCall(config.REPRO, `/netApps/${this.netAppId}/usagePriority`, param);
      this.processing = false;
      handler.validate(handler.validateTypes.all, leaveCCResponse, this, null, () => {
        // noop
      }, (result) => {
        // 処理が失敗したときのコールバック処理
        if (result.behaviorType === handler.behaviorTypes.logout) {
          this.logout(this);
        }
      });
    }
  },

  created() {
    // SSM5 非サポート車種の確認
    const isUnsupported = !this.vehicleInfo.is_ssm5_supported && !this.isTestMode && !this.vehicleInfo.is_sold_vehicle;
    if (isUnsupported) {
      this.$nextTick(() => {
        alert.showWarning(this, null, this.$t('message.message_function_menu_not_applicable_vehicle'),
          () => {
            // nop
          });
      });
    }

    // 個別診断メニューのリストを作成する
    this.createIndividualMenus();

    // 複数診断メニューのリストを作成する
    this.createMultipleMenus();

    // リプログラミング有無の確認
    const isDisplayRepro = this.hasReprogrammableSystem(this.systemTable ? this.systemTable.published : null);
    this.rprIconStyle = isDisplayRepro ? SELECTABLE : UNSELECTABLE;
    this.cacheDisplayReproTypeMode('campaign');

    // メニュー項目の有効化可否を設定
    this.initMenuStyles();

    // Menu画面では外部連携するサービスと車両通信が競合しないため、CC優先権を破棄する。
    this.leaveCCPriority();
  },

  mounted() {
    // リプロファイル画面からMenu画面へ遷移した場合に、targetUnitが選択されている場合の対応
    this.setTargetUnit(null);
  }
};
